import commonUtil from '../../common/commonUtil';
import { Label } from '../atoms/label';

export const SenyuubiTable = (props) => {
    const {
        shokaKenriList
    } = props;

    return (
        <div className='crawlSenyuubi_tableWrap'>
            <table className='crawlSenyuubi_table'>
                <tr>
                    <th className='crawlSenyuubi_tableHeaderCol'>占有日</th>
                    <th className='crawlSenyuubi_tableHeaderCol'>状態</th>
                </tr>
                {
                    shokaKenriList.map((shokaKenri, index) =>
                        <tr key={"senyuubi" + index} >
                            <td className={(shokaKenri.shokaKenriIroKbn == "red" ? 'crawlSenyuubi_tdColRed' :
                                shokaKenri.shokaKenriIroKbn == "gold" ? 'crawlSenyuubi_tdColGold' :
                                    shokaKenri.shokaKenriIroKbn == "blue" ? 'crawlSenyuubi_tdColBlue' :
                                        'crawlSenyuubi_tdCol') + " crawlSenyuubi_tdColLeft"}>
                                <Label label={shokaKenri.senyuDatHyojiOkFlg ? commonUtil.getStringFromDateJpnMembership(shokaKenri.shokaKenriDate) : shokaKenri.senyuDatHyojiDaitaiStr} />
                            </td>
                            <td className={shokaKenri.shokaKenriIroKbn == "red" ? 'crawlSenyuubi_tdColRed' :
                                shokaKenri.shokaKenriIroKbn == "gold" ? 'crawlSenyuubi_tdColGold' :
                                    shokaKenri.shokaKenriIroKbn == "blue" ? 'crawlSenyuubi_tdColBlue' :
                                        'crawlSenyuubi_tdCol'}>
                                <Label label={shokaKenri.jyotaiNam} />
                            </td>
                        </tr>
                    )
                }
            </table>
        </div>
    )
}